<template>
  <v-layout align-center justify-center>

    <v-flex xs12 sm8 md4>
      <v-card class="elevation-12">
        <div class="header-box">
            <v-img contain max-height="75" min-height="50" src="../../assets/de-logo_no_line.png" alt="Data Energy Metering and Billing Portal"></v-img>
        </div>

        <v-tabs
          grow
          v-model="tab"
          color="deep-purple-accent-4"
          align-tabs="center"
        >
          <v-tab :value="1">Metering &amp; Billing Portal</v-tab>
          <v-tab :value="2">Energy Portal</v-tab>
        </v-tabs>

        <v-window v-if="tab === 0">

          <InitialLogin @changeState="changeState" @utilityClick="pushToUtilityClick" @loginSuccess="successfulLogin" v-if="state === 'initial'"></InitialLogin>

          <ValidateEmail @changeState="changeState" v-if="state === 'require_verification'"></ValidateEmail>

          <TwoFactorSet @changeState="changeState" v-if="state === 'require_set2fa'"></TwoFactorSet>

          <TwoFactorVerify @changeState="changeState" @utilityClick="pushToUtilityClick" @loginSuccess="successfulLogin" v-if="state === 'require_2fa'"></TwoFactorVerify>
        </v-window>

        <v-window v-if="tab === 1">
          <h2 class="auth-heading">Energy Portal</h2>
          <v-card-text class="brokerage">
            <p>If you are a Managing Agent and we are managing your energy portfolio, please click below and log in with the details provided for you.</p>

            <p>If you do not have login details, please get in touch with your Energy Manager to register.</p>
            
            <div style="width: 75%;margin: auto;">
              <v-btn block class="center-button" color="primary" @click="accessBrokerage">Open Energy Portal</v-btn>
            </div>
          </v-card-text>
        </v-window>



        <v-divider class="mt-2 mx-4" />

        <v-card-actions class="px-4 text-caption grey--text">
          <div class="privacy-link">
            <span style="padding-right: 5px;">By logging in, you acknowledge our</span> <a href="https://dataenergy.co.uk/privacy-policy/" target="_blank">Privacy Policy</a>.
          </div>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import { get } from 'vuex-pathify';

import InitialLogin from "@/views/auth/login/InitialLogin";
import ValidateEmail from "@/views/auth/login/ValidateEmail";
import TwoFactorVerify from "@/views/auth/login/TwoFactorVerify";
import TwoFactorSet from "@/views/auth/login/TwoFactorSet";

export default {
  name: "Login",
  components: {
    InitialLogin,
    ValidateEmail,
    TwoFactorSet,
    TwoFactorVerify
  },
  metaInfo () {
    return {
      title: "Login"
    }
  },
  data: () => ({
    state: "initial",
    routeRedirect: null,
    tab: 0
  }),
  computed: {
    name: get('auth/isLoggedIn')
  },
  mounted() {
    this.routeRedirect = this.$route.query.redirect;
  },
  methods: {
    changeState(state) {
      if (!['initial', 'require_verification', 'require_set2fa', 'require_2fa'].includes(state)) {
        this.state = 'initial';
        return false;
      }

      this.state = state;
    },
    successfulLogin() {
      let path = "/";
      if (this.routeRedirect) {
        path = this.routeRedirect;
      }

      this.$router.push(path);
    },
    async pushToUtilityClick(email, path) {

      await this.$store.dispatch("loader/loaderInitiate", { title: "Redirecting to Utility Click" });
      window.location.href = process.env.VUE_APP_UTILITY_CLICK_PATH + "?email=" + email + "&code=" + path;

    },
    accessBrokerage() {
      this.$gtag.event("energy-portal", {
        event_category: "external-link",
      });

      window.location.href = "https://dataenergy.administrate.online/login?ReturnUrl=/login";
    }
  }
}
</script>

<style lang="scss" scoped>
.button {
  cursor:pointer;
}

.header-box {
  padding: 20px 0px 10px;
}

.privacy-link {
  margin: auto;
  width: 100%;
  text-align: center;
}

.brokerage p {
  text-align: center;
}

.center-button {
  width: 70%;
}

.auth-heading {
  text-transform: none !important;
  background-color: #5d3791;
  color: white !important;
  padding: 15px 10px;
}
</style>
